import { selectCurrentUserInfo } from 'store/slices/auth.slice';
import { useAppSelector } from 'store/store.hook';

import { useFetchNotificationsQuery, useFetchUserNotificationsQuery } from './notifications.api';

export type NotificationSettingsItem = {
  id: number;
  group: string;
  label: string;
  help: string;
  enabled: boolean;
  email: boolean;
  sms: boolean;
};

export const useNotifications = () => {
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);

  const { data = [], ...rest } = useFetchNotificationsQuery({ orgSlug });

  const notifications = data;

  return { data: notifications, ...rest };
};

export const useUserNotifications = () => {
  const { orgSlug, id: userId } = useAppSelector(selectCurrentUserInfo);

  const { data = [], ...rest } = useFetchUserNotificationsQuery({ orgSlug, userId });

  const all: NotificationSettingsItem[] = data
    .map((item: any) => {
      const { id = null, group = '', label = '', help = '', enabled = false, channels = {} } = item;
      const { email = false, sms = false } = channels;

      return {
        id,
        group,
        label,
        help,
        enabled,
        email,
        sms,
      };
    })
    .filter(({ id }: any) => !!id);

  const operational = all.filter((item) => item.group === 'operational');
  const zone = all.filter((item) => item.group === 'zone');

  return {
    data: {
      all,
      operational,
      zone,
    },
    ...rest,
  };
};
